import React from 'react';

import Switch from '../../../forms/Switch';

export default function AdChoices() {
  return(
    <Switch
      label="Ad Choices"
      name="adChoices"
    />
  )
}
